
import { ReactNode } from 'react';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
    return (
        <div className="min-h-screen bg-[#f8f9fb] font-sans text-slate-800">
            {children}
        </div>
    )
}

export default MainLayout;